import { grade11Part1 } from './data-part1';
import { grade11Part2 } from './data-part2';
import { grade11Part3 } from './data-part3';
import { grade11Part4 } from './data-part4';
import { grade11Part5 } from './data-part5';

export const grade11Data = [
  ...grade11Part1,
  ...grade11Part2,
  ...grade11Part3,
  ...grade11Part4,
  ...grade11Part5,
];
